module.exports = __webpack_public_path__ + "static/media/share-green-off.fd4bae9a.svg";